module.exports = __webpack_public_path__ + "static/thumbnail-leadrx-8112d6e3d73871f505d1c87fcde274d5.jpg";